import { Box, useTheme } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { tokens } from "../../../../theme";

import OverflowRow from "../../../../components/theme/OverflowRow";
import { OrdersTodayToProcessCard, OrdersFutureToProcessCard, OrdersActionRequiredCard, OrdersB2BCard } from "./components/OrdersTopRowCards";

// import { getOrderStatusCounts } from "../../../../api/orders/orders";
import { endOfMonth, format, startOfMonth } from "date-fns";
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { ORDER_FILTER_KEYS } from "../../../../components/global/DataGrid/Filter";
import TabView3 from "../../../../components/theme/TabView3/TabView3";
import usePinnedViews from "../../../../components/theme/TabView3/usePinnedViews";
import { useGetDashboardOrderTotalsQuery, useGetOrderTotalsQuery } from "../../../../newapi/order/ordersSlice";
import { useGetSettingsQuery } from "../../../../newapi/global/generalApiSlice";
import { selectUserPermission } from "../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from "../../../../utils/permissions";
import { general_states } from "../../../../utils/staticEnums";
import OutboundActionRequiredView from "./views/ActionRequired";
import OutboundAllView from "./views/All";
import OutboundAmazonFbaView from "./views/AmazonFba";
import OutboundBackorderView from "./views/Backorder";
import OutboundBolView from "./views/Bol";
import OutboundCancelledView from "./views/Cancelled";
import OrderLogs from "./views/OrderLogs";
import OutboundOrdersView from "./views/Orders";
import OutboundPausedView from "./views/Paused";
import OutboundPostponed from "./views/Postponed";
import OutboundReplenishView from "./views/Replenish";
import OutboundShipments from "./views/Shipments";
import OutboundShippedView from "./views/Shipped";
import OutboundSnoozedView from "./views/Snoozed";
import OutboundLabelPrintPendingView from "./views/LabelPrintPending";
import { VIEW_GROUPS, warehouseOutboundOrdersConfig } from "./warehouseOutboundOrdersConfig";
// import CustomerOrdersView from "./views/Customer";
import { AnimatePresence } from "framer-motion";
import { useTopbar } from "../../../../contexts/TopbarProvider";
import { defaultPollingInterval } from "../../../../utils/constants";

const locationChartStates = {
    open_count: "open_count",
    replenish_count: "replenish_count",
    backorder_count: "backorder_count",
    due_count: "due_count"
}

const TopRow = (props) => {
    const currentDate = new Date(); // or any date you want to use

    const [totalsDates, setTotalsDates] =useState({
        startDate : format(startOfMonth(currentDate), 'yyyy-MM-dd'),
        endDate : format(endOfMonth(currentDate), 'yyyy-MM-dd'),
    });

    const { data : totalData, isLoading,isFetching } = useGetDashboardOrderTotalsQuery({
        startDate: totalsDates.startDate,
        endDate: totalsDates.endDate
    }, { pollingInterval: 180000 }); // 3 minutes = 180000 milliseconds

    return (
        <OverflowRow>
            <Box
                sx={{
                    // background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                    flex:2,
                    // boxShadow: '0px 1px 2px 1px rgba(49, 65, 95, 0.15)',
                    position:"relative", //Needed for absolutely positioned things
                    // width:1,
                    borderRadius:4,
                    display:"flex",
                    gap:(totalData?.today_now_b2b != null && totalData.today_now_b2b > 0) ? 1.5 : 3,
                    // "@media screen and (max-width: 47.9375em)" : {
                    //     width: "unset"
                    // }
                }}
            >
                <OrdersTodayToProcessCard totalData={totalData} isLoading={isLoading} isFetching={isFetching} />

                <OrdersFutureToProcessCard totalData={totalData} isLoading={isLoading} isFetching={isFetching} />

                <OrdersActionRequiredCard totalData={totalData} isLoading={isLoading} isFetching={isFetching} />

                <AnimatePresence initial={false}>
                    {totalData?.today_now_b2b != null && totalData.today_now_b2b > 0 && (
                        <OrdersB2BCard totalData={totalData} isLoading={isLoading} isFetching={isFetching} />
                    )}
                </AnimatePresence>
                
                        {/* <OrderDashboardCard
                            logo={<CallMadeOutlinedIcon className="logo"/>}
                            changeChartType={changeChartType}
                            locationChartType={locationChartStates?.open_count}
                            isLoading={isLoading || isFetching}
                            data={totalData}
                            value={totalData?.open_count?.value}
                            type={totalData?.open_count?.label}
                            displayType={"text"}
                            color={"lightblue"}
                            active={chartType === locationChartStates?.open_count}

                        /> */}

                        {/* <OrderDashboardCard
                            logo={<CallMadeOutlinedIcon className="logo"/>}
                            changeChartType={changeChartType}
                            locationChartType={locationChartStates?.maintenance_count}
                            isLoading={isLoading || isFetching}
                            data={totalData}
                            type={totalData?.maintenance_count?.label}
                            value={totalData?.maintenance_count?.value}
                            displayType={"text"}
                            color="red"
                            active={chartType === locationChartStates?.maintenance_count}
                        /> */}
                        {/* <OrderDashboardCard
                            logo={<CallMadeOutlinedIcon className="logo"/>}
                            changeChartType={changeChartType}
                            locationChartType={locationChartStates?.replenish_count}
                            isLoading={isLoading || isFetching}
                            data={totalData}
                            value={totalData?.replenish_count?.value}
                            type={totalData?.replenish_count?.label}
                            displayType={"text"}
                            color={"grey"}
                            active={chartType === locationChartStates?.replenish_count}
                        /> */}

                        {/* <OrderDashboardCard
                            logo={<CallMadeOutlinedIcon className="logo"/>}
                            changeChartType={changeChartType}
                            locationChartType={locationChartStates?.postponed_count}
                            isLoading={isLoading || isFetching}
                            data={totalData}
                            type={totalData?.postponed_count?.label} 
                            value={totalData?.postponed_count?.value}
                            color={"grey"}
                            displayType={"text"}
                            active={chartType === locationChartStates?.postponed_count}
                        /> */}
                        
                </Box>


        </OverflowRow>
    )
}


const OutboundOrders = () => {
    const { t, ready,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const state = queryParams.get('state'); // "MAINTENANCE"

    // Enable URL-based view navigation (enabled by default)
    // const tabViewUrl = useTabViewUrl();

    const {showExtraTitle,clearExtraTitle } = useTopbar();
    const [tableConfig, setTableConfig] = useState({
        [ORDER_FILTER_KEYS.STATE.backend_key]:state !== null ? [general_states[state]] : [general_states.OPEN, general_states.PICKING_IN_PROGRESS, general_states.FULLYPICKED, general_states.ECHECK, general_states.TO_PROCESS]
    });

    useEffect(() => {
        setTableConfig ({
            [ORDER_FILTER_KEYS.STATE.backend_key]:state !== null ? [general_states[state]] : [general_states.OPEN, general_states.PICKING_IN_PROGRESS, general_states.FULLYPICKED, general_states.ECHECK, general_states.TO_PROCESS]
        });

    },[state]);
    
    const { data : orderTotals, isLoading: totalIsLoading, refetch: refetchOrderTotals } = useGetOrderTotalsQuery("state", { pollingInterval: defaultPollingInterval });
    const isFulfilment = useSelector((state) => state.settings.environment.isFulfilment);
    const hasAmazonManagePermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.AMAZON_MANAGE])
    );

    // Refetch the tab-label totals whenever the active TabView3 view changes,
    // so switching tabs shows fresh counts without waiting for the poll or an F5.
    const activeView = queryParams.get('view');
    const didMountTotals = useRef(false);
    useEffect(() => {
        if (!didMountTotals.current) {
            didMountTotals.current = true;
            return;
        }
        refetchOrderTotals();
    }, [activeView, refetchOrderTotals]);

    // Orders finalized in the e-check without their label get a view to print those labels
    const { data: eCheckSettings } = useGetSettingsQuery("echeck");
    const showLabelPrintPending = eCheckSettings?.find(setting => setting.key === 'echeck_finalize_without_label')?.value === "true";

    const [config, setConfig] = useState(warehouseOutboundOrdersConfig(isFulfilment, undefined, false, hasAmazonManagePermission));

    useEffect(() => {
        setConfig(warehouseOutboundOrdersConfig(isFulfilment, orderTotals, showLabelPrintPending, hasAmazonManagePermission));
    }, [isFulfilment,orderTotals,showLabelPrintPending,hasAmazonManagePermission]);

    const { pinnedKeys, togglePin } = usePinnedViews("warehouseOutboundOrders", Object.keys(config));



    useEffect(() => {
        showExtraTitle(t("orders"))

        return () => {
            clearExtraTitle();
        };
    }, [showExtraTitle,clearExtraTitle,t,i18n.language])

    return (
        <Box sx={{background:"", width:1,paddingTop:9}}>
            <TopRow
                setTableConfig={setTableConfig}
            />

            <TabView3
                tabConfig={config}
                pinnedViews={{
                    pinnedKeys,
                    groups: VIEW_GROUPS,
                    onTogglePin: togglePin,
                }}
                sx={{
                    background:"green",
                    minHeight:"calc(100% - 190px)",
                    background: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    position:"relative",
                    zIndex:2,
                    display:"flex",
                    flexDirection:"column",

                    "&:before" : {
                        content: "''",
                        display:"block",
                        width:"32px",
                        height:"32px",
                        position:"absolute",
                        left:0,
                        top:0,
                        zIndex:1,
                        backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        top:"40px",
                        height:"48px",
                        width:"24px",
                        borderTopLeftRadius:"24px",
                        boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                        transition:"250ms"
                    },

                    "&:after" : {
                        content: "''",
                        display:"block",
                        width:"32px",
                        height:"32px",
                        position:"absolute",
                        top:0,
                        zIndex:1,
                        backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        top:"40px",
                        right:0,
                        height:"48px",
                        width:"24px",
                        borderTopLeftRadius:"24px",
                        boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                        transform:"scaleX(-1)",
                        transition:"250ms"
                    },

                    "@media screen and (max-width: 47.9375em)" : {
                        "&:after, &:before" : {
                            top:"-0px"
                        }
                    }
                }}
            >
                <>
                    <OutboundOrdersView tableConfig={tableConfig} config={config.orders}/>
                    <OutboundPausedView config={config.paused} />
                    <OutboundReplenishView config={config.replenish} />
                    <OutboundPostponed tableConfig={tableConfig} config={config.postponed}/>
                    <OutboundShippedView config={config.shipped}/>
                    <OutboundSnoozedView config={config.snoozed}/>
                    {showLabelPrintPending && (<OutboundLabelPrintPendingView config={config.labelPrintPending}/>)}
                    <OutboundActionRequiredView config={config.actionRequired} />
                    <OutboundBackorderView config={config.backorders}/>
                    <OutboundCancelledView config={config.cancelled}/>
                    <OutboundAllView config={config.all}/>
                    <OutboundBolView config={config.bol}/>
                    {hasAmazonManagePermission && (<OutboundAmazonFbaView config={config.amazonFba}/>)}
                    <OutboundShipments config={config.shipments}/>
                    {!isFulfilment && (<OrderLogs config={config.importLogs}/>)}
                </>
            </TabView3>
                {/* </TabView> */}
        </Box>
    );
};

export default OutboundOrders;